export default "__VITE_ASSET__967f5bea__"